/**
 * Google Ads + Meta Pixel conversion tracking utilities
 * GA / Google Ads Tag ID: AW-17941368108
 */

const GA_TRACKING_ID = 'AW-17941368108';

function gtag() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag.apply(null, arguments);
  }
}

function fbq() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq.apply(null, arguments);
  }
}

/**
 * Track a click on any "Book Now" CTA across the site
 * @param {string} label - Identifies which CTA was clicked (e.g. "hero", "after_how_it_works", "mid_page")
 */
export function trackBookCtaClick(label) {
  gtag('event', 'book_cta_click', {
    event_category: 'engagement',
    event_label: label,
    send_to: GA_TRACKING_ID
  });
  fbq('trackCustom', 'BookCtaClick', {
    cta_location: label
  });
}

/**
 * Track a /book page view as a conversion-eligible event
 */
export function trackBookPageView() {
  gtag('event', 'page_view', {
    page_path: '/book',
    page_title: 'Book — NorCal Mobile Oil Change',
    send_to: GA_TRACKING_ID
  });
  gtag('event', 'view_book_page', {
    event_category: 'engagement',
    event_label: 'Booking page viewed'
  });
  fbq('track', 'ViewContent', {
    content_name: 'Booking Page',
    content_category: 'booking'
  });
}

/**
 * Track a completed booking as a Google Ads conversion
 * @param {Object} booking - The booking object
 */
export function trackBookingConversion(booking) {
  gtag('event', 'conversion', {
    send_to: GA_TRACKING_ID,
    value: booking.totalPrice || 0,
    currency: 'USD',
    transaction_id: booking.confirmationNumber
  });

  // Also fire a custom event for Google Ads conversion actions
  gtag('event', 'purchase', {
    send_to: GA_TRACKING_ID,
    value: booking.totalPrice || 0,
    currency: 'USD',
    transaction_id: booking.confirmationNumber,
    items: [{
      item_name: booking.service || 'Oil Change',
      price: booking.totalPrice || 0,
      quantity: 1
    }]
  });

  // Meta Pixel: standard Lead + Purchase events for booking submission
  fbq('track', 'Lead', {
    content_name: booking.service || 'Oil Change',
    value: booking.totalPrice || 0,
    currency: 'USD'
  });
  fbq('track', 'Purchase', {
    content_name: booking.service || 'Oil Change',
    value: booking.totalPrice || 0,
    currency: 'USD'
  });
}

/**
 * Track phone call clicks as a conversion event
 */
export function trackPhoneCallClick() {
  gtag('event', 'conversion', {
    send_to: GA_TRACKING_ID,
    value: 0,
    currency: 'USD'
  });
}

/**
 * Track SMS/text clicks as a conversion event
 */
export function trackSmsClick() {
  gtag('event', 'conversion', {
    send_to: GA_TRACKING_ID,
    value: 0,
    currency: 'USD'
  });
  gtag('event', 'sms_click', {
    event_category: 'engagement',
    event_label: 'Text Us button'
  });
}

/**
 * Install global click listener for tel: and sms: links
 * Call once on app mount
 */
export function initPhoneClickTracking() {
  document.addEventListener('click', (e) => {
    const telLink = e.target.closest('a[href^="tel:"]');
    if (telLink) {
      trackPhoneCallClick();
      return;
    }
    const smsLink = e.target.closest('a[href^="sms:"]');
    if (smsLink) {
      trackSmsClick();
    }
  });
}
